import { css } from "lit";

export const styles = css`
  .question-slide {
    --question-slide-icon-container-width: 100px;
    background-color: var(--color-white);
    width: 100%;
    height: 100%;
    display: block;
  }

  .content-container {
    height: var(--slide-default-height);
    width: 100%;
    padding: 0 var(--size-7);
    box-sizing: border-box;
    display: grid;
    place-items: center;
  }

  .content {
    font-size: var(--font-size-5xl);
    line-height: var(--line-height-snug);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--size-3);
  }

  .icon-container {
    aspect-ratio: 1 / 1;
    color: var(--color-white);
    width: var(--question-slide-icon-container-width);
    flex-shrink: 0;
    align-self: flex-start;
    background-color: var(--slide-accent-color);
    border-radius: var(--radius-full);
    display: grid;
    place-items: center;
  }

  .icon {
    display: inline-block;
    fill: var(--icon-color, currentColor);
    height: var(--icon-size);
    width: var(--icon-size);
  }
`;
